import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { Link } from 'react-router-dom';
import MotionReveal from '../motion/MotionReveal';
import SectionProcessBg from '../components/SectionProcessBg';
import CaseStudyCard from '../components/CaseStudyCard';
import { CASE_STUDIES } from '../data/caseStudies';
import { fadeUp, staggerContainer } from '../motion/variants';

export default function CaseStudiesSection({ limit = 6, showAllLink = true }) {
  const reduceMotion = useReducedMotion();
  const items = CASE_STUDIES.slice(0, limit);

  return (
    <section id="case-studies" className="sec sec-process-wrap cs-section" data-palette="cloud">
      <SectionProcessBg variant="analytics" seed={5} />
      <div className="cs-section__ambient" aria-hidden="true">
        <span className="cs-section__orb cs-section__orb--1" />
        <span className="cs-section__orb cs-section__orb--2" />
      </div>
      <div className="sec-process-content">
        <motion.div
          className="cs-hdr"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <motion.div variants={fadeUp}>
            <div className="kicker k-gold">Get Inspired</div>
            <h2 className="title lt">
              Innovation
              <br />
              <em>in action</em>
            </h2>
          </motion.div>
          <motion.p className="cs-sub" variants={fadeUp}>
            Real formulations solving real challenges — tagged by product line and polymer substrate.
          </motion.p>
        </motion.div>

        <motion.div
          className="cs-grid"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.08 }}
        >
          {items.map((cs, i) => (
            <CaseStudyCard key={cs.id} study={cs} index={i} reduceMotion={reduceMotion} />
          ))}
        </motion.div>

        {showAllLink && (
          <MotionReveal className="cs-footer">
            <Link to="/innovation" className="btn-g">
              View all case studies →
            </Link>
          </MotionReveal>
        )}
      </div>
    </section>
  );
}
